module.exports = __webpack_public_path__ + "whitelightbulb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitelightbulb.png
// module id = 892
// module chunks = 0